import { Skeleton } from '@/shared/ui/Skeleton';
import skeletonStyles from './DashboardSkeleton.module.css';

/**
 * Loading skeleton for the Dashboard page.
 * Mirrors the grid and hero layout of the active dashboard to
 * prevent layout shifts during data ingestion.
 */
export function DashboardSkeleton() {
  return (
    <div className={skeletonStyles.dashboardShell} data-testid="dashboard-skeleton">
      {/* Leadership Quotes Skeleton */}
      <section className={skeletonStyles.cardSecondary}>
        <Skeleton width="40%" height={24} className={skeletonStyles.titleSpacing} />
        <Skeleton width="100%" height={60} />
      </section>

      {/* Grid Section Skeleton */}
      <section className={skeletonStyles.sectionGrid}>
        {/* User Overview Skeleton */}
        <div className={skeletonStyles.card}>
          <div className={skeletonStyles.avatarRow}>
            <Skeleton variant="circular" width={64} height={64} />
            <div className={skeletonStyles.avatarText}>
              <Skeleton width="60%" height={24} className={skeletonStyles.lineSpacing} />
              <Skeleton width="40%" height={18} />
            </div>
          </div>
          <Skeleton width="100%" height={100} />
        </div>

        {/* Leader Dashboard Skeleton */}
        <div className={skeletonStyles.card}>
          <Skeleton width="50%" height={24} className={skeletonStyles.cardTitleSpacing} />
          <div className={skeletonStyles.listStack}>
            <Skeleton width="100%" height={40} />
            <Skeleton width="100%" height={40} />
            <Skeleton width="100%" height={40} />
          </div>
        </div>
      </section>

      {/* Learning Resources Skeleton */}
      <section>
        <Skeleton width={200} height={28} className={skeletonStyles.titleSpacing} />
        <div className={skeletonStyles.grid}>
          {[1, 2, 3].map((i) => (
            <div key={i} className={skeletonStyles.resourceCard}>
              <Skeleton height={160} />
              <div className={skeletonStyles.resourceContent}>
                <Skeleton width="80%" height={20} className={skeletonStyles.lineSpacing} />
                <Skeleton width="40%" height={16} />
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
